import React from 'react';

interface AdminFormProps {
  leftColumn?: React.ReactNode;
  rightColumn?: React.ReactNode;
  onSubmit: (e: React.FormEvent) => void;
  formActions: React.ReactNode;
  children?: React.ReactNode;
}

const AdminForm: React.FC<AdminFormProps> = ({
  leftColumn,
  rightColumn,
  onSubmit,
  formActions,
  children
}) => {
  return (
    <div id="form-section" className="bg-white rounded-lg shadow-sm">
      <div className="p-8">
        <form id="admin-form" onSubmit={onSubmit} noValidate>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div id="left-column">
              {leftColumn}
            </div>
            <div id="right-column">
              {rightColumn}
            </div>
          </div>
          
          {children}
          
          <div id="form-actions" className="flex justify-end space-x-4 pt-6 border-t border-gray-200">
            {formActions}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminForm;
